import Success from "@timeedit/ui-components/icons/Success";
import Info from "@timeedit/ui-components/icons/Info";
import ErrorIcon from "@timeedit/ui-components/icons/Error";
import Warning from "@timeedit/ui-components/icons/Warning";
import { CapitalizedNoticeType } from "../../hooks/types";
import { exhaustiveMatchingGuard } from "@timeedit/registration-shared";

type SeverityIconProps = {
  type: CapitalizedNoticeType;
  className?: string;
};

export function SeverityIcon({
  type,
  className,
}: SeverityIconProps): React.ReactNode {
  switch (type) {
    case "Success":
      return <Success alt={type} size={24} className={className} />;
    case "Info":
      return <Info alt={type} size={24} className={className} />;
    case "Error":
      return <ErrorIcon alt={type} size={24} className={className} />;
    case "Warning":
      return <Warning alt={type} size={24} className={className} />;
    default:
      return exhaustiveMatchingGuard(type);
  }
}
